define([
  'underscore',
  'mailcheck',
], (_, Mailcheck) => {
  const _domains = ["gmail.com", "hotmail.com", "yahoo.com", "outlook.com", "aol.com", "live.com", "me.com", "icloud.com", "mail.ru", "hotmail.co.uk", "yahoo.co.uk", "facebook.com", "ymail.com", "yandex.ru", "msn.com", "comcast.net", "mail.com", "mac.com", "hotmail.fr", "googlemail.com", "yahoo.fr", "gmx.de", "qq.com", "web.de", "yahoo.es", "live.co.uk", "yahoo.com.br", "att.net", "sbcglobal.net", "yahoo.ca", "rocketmail.com", "abv.bg", "btinternet.com", "verizon.net", "hotmail.it", "gmx.com", "hotmail.es", "cox.net", "seznam.cz", "live.fr", "yandex.com", "yahoo.co.in", "yahoo.co.id", "mailinator.com", "bigpond.com", "yahoo.com.au", "yahoo.it", "libero.it", "yopmail.com", "yahoo.de", "yahoo.in", "wp.pl", "163.com", "shaw.ca", "ntlworld.com", "rediffmail.com", "bk.ru", "naver.com", "bellsouth.net", "gmx.net", "live.nl", "live.ca", "outlook.fr", "free.fr", "o2.pl", "kw.com", "ukr.net", "ya.ru", "outlook.es", "orange.fr", "earthlink.net", "rogers.com", "hotmail.de", "live.com.au", "charter.net", "rambler.ru", "yahoo.co.jp", "yahoo.gr", "hotmail.ca"];
  const _cached = [];

  function isEmailValid(email) {
    if (!email) email = '';

    return ((email.indexOf('@') > 0) // Has @ but not at start.
      && (email.split('@').length === 2) // Has only one @.
      && (email.split('@')[1].indexOf('.') > 0) // Has period after @.
      && (email.indexOf('.') !== email.length - 1) // Has period not at end.
    )
  }

  function domainSpellCheck(email, callback) {
    if (!isEmailValid(email)) return callback([]);

    Mailcheck.run({
      email: email,
      domains: _domains,
      suggested: function(suggestion) {
        callback('full' in suggestion ? [suggestion.full] : []);
      },
      empty: function() {
        callback([]);
      }
    });
  }

  function suggest(str) {
    const emailArray = str.split('@');
    if (emailArray.length < 2) return '';

    str = emailArray.pop();

    const match = _domains.filter(function (domain) {
      return 0 === domain.indexOf(str);
    });

    if (match && str.indexOf(match) === -1) return match;
    return (match.shift() || '').replace(str, '');
  }

  function suggests(str, callback) {
    domainSpellCheck(str, function(spellingSuggestions) {

      let matchedDomains = suggest(str) || [];
      let matchedEmails = _cached.filter(function (cached) {
        return (0 === cached.indexOf(str) && cached !== str);
      });

      // Check if matches a prior: if so then suggest other priors.
      let matchedEmail = _cached.filter(function (cached) {
        return (0 === cached.indexOf(str) && cached === str);
      });

      if (matchedEmail.length) {
        const emails = _cached.slice(0);

        emails.splice(emails.indexOf(matchedEmail[0]), 1);
        emails.unshift(matchedEmail[0]);

        matchedEmails = emails;
      } else if (!str.length) {
        matchedEmails = _cached.slice(0);
      }

      for (let i = 0; i < matchedDomains.length; i++) {
        matchedDomains[i] = str.substr(0, str.lastIndexOf('@')) + '@' + matchedDomains[i];
      }

      callback(matchedEmails.concat(matchedDomains).slice(0, 7), spellingSuggestions);
    });
  }

  return {
    suggests: suggests,
  };
});
